import { startSavingDocumentChanges, DOCUMENTS } from '@ratehub/base-ui';


function startSavingMortgageJourney(document, { sessionStore }) {
    startSavingDocumentChanges(sessionStore, document, DOCUMENTS.MORTGAGE_JOURNEY.PATH);
}

export default startSavingMortgageJourney;
